import styled from "styled-components";

export default styled.i`
  position: absolute;
  bottom: 0;
  left: 50%;
  font-size: 2rem;
`;
